import React from 'react';

import introImg from '../../../../assets/images/courses/teamplayer&collaboration/chapter8.1.jpg';
import chapterImg1 from '../../../../assets/images/courses/teamplayer&collaboration/chapter8.2.1.jpg';
import chapterImg2 from '../../../../assets/images/courses/teamplayer&collaboration/chapter8.2.2.jpg';
import chapterImg3 from '../../../../assets/images/courses/teamplayer&collaboration/chapter8.2.3.jpg';
import chapterImg4 from '../../../../assets/images/courses/teamplayer&collaboration/chapter8.3.1.jpg';
import chapterImg5 from '../../../../assets/images/courses/teamplayer&collaboration/chapter8.3.2.jpg';
import { CourseChapter } from '../../../../courses/courses.types';
import { InfoBlock } from '../../InfoBlock';
import { MediaBlock } from '../../MediaBlock';
import { TabsBlock } from '../../TabsBlock';

interface TeamPlayersAndCollaborationChapter1 {
  chapter: CourseChapter;
  onNextChapter: (nextIndex: number) => void;
  totalPages: number;
  courseId?: string;
  onQuizResult?: (result: boolean | undefined) => void;
}

export const TeamPlayersAndCollaborationChapter8: React.FC<TeamPlayersAndCollaborationChapter1> = ({
  chapter,
  onNextChapter,
  totalPages,
}) => {
  const handleNextChapterClick = () => {
    onNextChapter(chapter.index + 1);
  };

  const handlePrint = () => {
    const printArea = document.getElementById('print-view');
    if (printArea) {
      printArea.classList.add('print-view');

      const cleanup = () => {
        printArea.classList.remove('print-view');
        window.onafterprint = null;
      };

      window.onafterprint = cleanup;

      window.print();
    }
  };

  const showYoureListeningTabData = [
    {
      title: 'Language Reframing',
      mediaImage: chapterImg1,

      htmlContent: `<p>This is a technique that involves changing the way that we talk about a problem to make it more amenable to solutions. For example, reframe problem to opportunity. Let's say your company is facing financial difficulties. Rather than saying, "We are in financial trouble and don't know what to do," you could say, "We see this as an opportunity to reevaluate our business model and find new ways to increase revenue and cut costs, improving our financial health in the long run." This way, you're more open-minded to creative solutions and can emerge from the situation even stronger than before. 
Another example is reframing failure to learning experience. Let's say you perform poorly in a client pitch. Rather than saying, "I can't believe this happened. I failed," reframe to, "I see this as a learning experience. I'll prepare better and get feedback so I do better with the next pitch." This way, you're more proactive, rather than feeling defeated. These simple shifts in language can have a profound effect on how we approach the problem, encouraging us to think more positively and creatively.</p>`,
    },
    {
      title: 'Collective Curiosity',
      mediaImage: chapterImg2,
      htmlContent: `<div><p>A true solution orientation requires you to ask curious questions to the root of the issue and to think more creatively. By asking how questions, teams can begin to explore different approaches and creative solutions. For example:

<ol className="list-decimal pl-5 mb-14 text-xl font-light">

</ol>
<li>How can we reduce costs without sacrificing quality?</li>
<li>How can we use existing resources more efficiently?</li>
<li>How can we streamline our workflow to eliminate unnecessary steps and reduce waste?</li>
<li>How can we negotiate better terms with suppliers or vendors to lower our costs?</li>
<li>How can we negotiate better terms with suppliers or vendors to lower our costs?</li>

<li>How can we automate certain tasks to save time and money?</li>

 </p> </div>`,
    },
    {
      title: 'Offer Solutions',
      mediaImage: chapterImg3,
      htmlContent: `<p>Rather than just complaining about a problem or a task, brainstorm at least three potential solutions along with pros and cons. This not only helps you develop a skill called cognitive flexibility, it also helps the team move forward faster and makes it easier to identify what solution's going to work best. </p>`,
    },
  ];
  return (
    <>
      <div className="content-wrap lg:border-l lg:pl-8 lg:pt-8 pt-4 pb-10">
        <p className="text-sm italic  mb-7">
          Part {chapter.index} of {totalPages}
        </p>
        <h2 className="font-semibold text-3xl">Develop Your Solution-Orientation</h2>
        <br />
        <MediaBlock mediaImage={introImg}></MediaBlock>
        <br />
        <p className="text-2xl text-center font-light mt-10 mb-10">
          Solution orientation is a critical skill that encourages everyone in the team to work
          together towards finding solutions rather than just pointing out problems. Here are three
          tips to cultivate your solution orientation.
        </p>
        <TabsBlock tabsData={showYoureListeningTabData} />
        <p className="text-2xl text-center font-light mt-10 mb-10">
          By incorporating solution orientation into your day-to-day thinking, you can become an
          invaluable asset to any team. Not only will you be able to identify problems and offer
          solutions, but you'll also encourage the team to work together towards finding the best
          solution.
        </p>
        <br />
        <h3 className="text-2xl text-purple-600 font-bold mt-10 m-5">Reflect</h3>
        <div id="print-view" className="mb-10 mt-10">
          <p className="text-lg font-semibold flex-1 mt-5 mb-5">
            Reflect and complete the questions below. You may print your responses upon completion.{' '}
          </p>
          <ol className=" list-decimal pl-7 mb-14 text-xl font-light">
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                When have I demonstrated a solution-orientation in the past, and what can I learn
                from those experiences?
              </p>
              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                How can I shift my perspective from seeing problems as obstacles to seeing them as
                opportunities for growth and innovation?
              </p>
              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                How can I stay focused on my goals and stay motivated to find solutions, even when
                faced with setbacks or failures?
              </p>
              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
            <li>
              <p className="text-xl font-light flex-1 mt-5 mb-5">
                How will I develop my solution-orientation and become more adept at finding creating
                solutions?
              </p>
              <textarea
                className="w-full  h-32 p-2 border rounded"
                placeholder="Enter your text here..."
              ></textarea>
            </li>
          </ol>

          <div className="mt-5 text-right">
            <button onClick={handlePrint} className="btn-internal">
              PRINT
            </button>
          </div>
        </div>
        <br /> <h3 className="text-2xl text-purple-600 font-bold mt-10 mb-1">Summary</h3>
        <div className="md:flex items-center mt-10 mb-10">
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg4} alt="" />
          </div>
          <p className="flex-1 leading-7">
            Improving your strategic thinking and focusing on solutions are key skills that can make
            a big difference in how you contribute to any team. By asking smart questions, thinking
            about worst-case scenarios, finding gaps, and reviewing what worked and what didn’t, you
            can boost your strategic thinking.
          </p>
        </div>
        <InfoBlock
          title="Note: "
          text="You may want to check out another one of our courses that looks at improving your critical thinking skills."
        />
        <div className="md:flex items-center mt-10 mb-10">
          <p className="flex-1 leading-7">
            <br />
            By changing how you talk about problems, staying curious, and coming up with possible
            solutions, you can help your team work together better and find the best answers. These
            skills not only make you a better team player but also help create a positive and
            creative team environment.
          </p>
          <div className="md:mr-8 max-w-full md:max-w-xs w-full mb-5 md:mb-0">
            <img src={chapterImg5} alt="" />
          </div>
        </div>
        <br />
        <p className="text-2xl text-center font-normal mt-5 mb-10">
          By practicing these strategies, you can become an important part of your team's success.
          Next up, we're exploring how to deal with the inevitability of disagreements in teams.
        </p>
        <br />
        <button onClick={handleNextChapterClick} className="btn-internal w-full">
          Difficulties That Teams Face
        </button>
      </div>
    </>
  );
};
